<div class="header">
  <div class="title">
    <div class="title-text">Medical Notes</div>
  </div>
  <span class="message">* populated from PatientNow</span>
</div>
<hr class="divider" />
<fb-simple-table [data]="data()">
  <ng-container fbSimpleTableColumnDef>
    <ng-template fbSimpleTableHeaderCellDef>Date</ng-template>
    <ng-template fbSimpleTableCellDef let-note>{{ note.date | date: 'MM/dd/yyyy' }}</ng-template>
  </ng-container>
  <ng-container fbSimpleTableColumnDef>
    <ng-template fbSimpleTableHeaderCellDef>Employee</ng-template>
    <ng-template fbSimpleTableCellDef let-note>{{ note.employeeName || note.employeeId }}</ng-template>
  </ng-container>
  <ng-container fbSimpleTableColumnDef>
    <ng-template fbSimpleTableHeaderCellDef>Medical Note</ng-template>
    <ng-template fbSimpleTableCellDef let-note>
      <span class="medical-note-cell">
        <span>{{ note.text }}</span>
        <fb-scribe-suggestion-indicator [target]="note" variant="compact"></fb-scribe-suggestion-indicator>
        <fb-amendment-field-indicator [rowIndex]="getAmendmentRowIndex(note)" />
      </span>
    </ng-template>
  </ng-container>
</fb-simple-table>
<hr class="divider" />
@if (isEmrReadonly()) {
  <fb-emr-readonly-notice />
} @else {
  <div class="action">
    <rx-icon name="icon-circle-plus-2" class="action-icon" />
    <span class="action-label">Add Medical Note</span>
  </div>
}
